export const adaptAreaPayload = (
	values: AreaFormValues
): Record<string, unknown> => {
	// Manager id is a MeeUser GUID string on the .NET backend; only the
	// region id is numeric, so don't coerce areaManager to Number.
	return {
		name: values.name,
		region: values.region !== "" ? Number(values.region) : null,
		area_manager: values.areaManager !== "" ? values.areaManager : null
	};
};
